import React, { Component } from 'react'

export default class Error extends Component {
  render() {
    return (
      <div>
        <h1>Oops! Page not found!</h1>
      </div>
    )
  }
}
